import script from "./AggiungiWatcherButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AggiungiWatcherButton.vue?vue&type=script&setup=true&lang=js"

import "./AggiungiWatcherButton.vue?vue&type=style&index=0&id=7f36843a&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f36843a"]])

export default __exports__